"use strict";
(function () {

    // .Net like string format
    if (!String.format) {
        String.format = function (format) {
            var args = Array.prototype.slice.call(arguments, 1);
            return format.replace(/{(\d+)}/g, function (match, number) {
                return typeof args[number] != 'undefined' ? args[number] : match;
            });
        };
    }

    if (!Array.indexByKey) {
        Array.indexByKey = function (array, key, value) {
            var values = $.map(array, function (item) {
                return item[key];
            });
            return values.indexOf(value);
        };
    }

    if (!Array.moveItem) {
        Array.moveItem = function (array, fromIndex, toIndex) {
            array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
        };
    }

    if (!Array.findObject) {
        Array.findObject = function (array, key, value, throwError) {
            for (var i = 0, len = array.length; i < len; i++) {
                if (array[i][key] === value) {
                    return array[i]; // Return as soon as the object is found
                }
            }
            if (throwError) {
                throw String.format("Object with {0}: {1} has not been found.", key, value);
            }
            else {
                return -1;
            }
        };
    }
    if (!Array.findObjectIndex) {
        Array.findObjectIndex = function (array, key, value, throwError) {
            for (var i = 0, len = array.length; i < len; i++) {
                if (array[i][key] === value) {
                    return i; // Return as soon as the object is found
                }
            }
            if (throwError) {
                throw String.format("Object with {0}: {1} has not been found.", key, value);
            }
            else {
                return -1;
            }
        };
    }
})();